export const ru = {
    'table-streams-copy-link-title-permanent': 'Постоянная ссылка на трансляцию',
    'table-streams-copy-link-title': 'Ссылка на трансляцию',
    stream: 'Трансляция',
    chat: 'Чат',
    'copy-stream-link': 'Скопировать ссылку на трансляцию',
    'copy-chat-link': 'Скопировать ссылку на чат',
};
